import Croppie from 'croppie';

export default class CroppieTest {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.vanillaResult = document.querySelector('.vanilla-result');
    this.vanillaSave = document.querySelector('.vanilla-save');
    this.vanillaRotate = document.querySelector('.vanilla-rotate');
    this.image = this.el.getAttribute('data-file');
    this.demoVanilla();
  }

  demoVanilla() {
    const vanilla = new Croppie(document.getElementById('vanilla-demo'), {
      viewport: {
        width: 81,
        height: 108
      },
      boundary: {
        width: 450,
        height: 600
      },
      enableOrientation: true
    });
    vanilla.bind({
      url: this.image
    });
    this.vanillaResult.addEventListener('click', () => {
      vanilla
        .result({
          type: 'canvas',
          format: 'jpeg',
          quality: 1
        })
        .then(this.resultVanilla(vanilla.result));
    });
    this.vanillaSave.addEventListener('click', () => {
      vanilla
        .result({
          type: 'canvas',
          format: 'jpeg',
          quality: 1
        })
        .then(this.saveVanilla(vanilla.result));
    });
    this.vanillaRotate.addEventListener('click', e => {
      vanilla.rotate(parseInt(e.target.getAttribute('data-deg'), 10));
    });
  }

  resultVanilla(result) {
    // console.log(result);
    // console.log('result von resultVanilla', result);
    const resultWrapper = document.getElementById('vanilla-cropped');
    const img = new Image();
    img.src = result;
    resultWrapper.innerHTML = '';
    resultWrapper.appendChild(img);
    const data = {
      file: result,
      otra: 'otra c'
    };
    $.ajax({
      url: 'operations.php',
      method: 'POST',
      type: 'json',
      data,
      success: () => {
        // console.log(response);
      }
    });
  }

  saveVanilla(result) {
    return result;
    // console.log(result);
    // console.log('result von saveVanilla', result);
    // let textStr = `<a id="save" href="${result}" download="result">`;
    // textStr = `${textStr}<img src="${result}" /><br>`;
    // textStr = `${textStr}<button>Download</button></a>`;
    // console.log(textStr);
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/_croppietest.js